import { render, staticRenderFns } from "./ProductCardInner.vue?vue&type=template&id=b66d69ea&scoped=true&"
import script from "./ProductCardInner.vue?vue&type=script&lang=ts&"
export * from "./ProductCardInner.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCardInner.vue?vue&type=style&index=0&id=b66d69ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66d69ea",
  null
  
)

export default component.exports